"use client"

import Link from "next/link"
import { ArrowRight, Play } from "lucide-react"
import { useState } from "react"

export function HeroSection() {
  const [videoOpen, setVideoOpen] = useState(false)

  return (
    <section className="relative overflow-hidden section-container pt-32 md:pt-40 pb-20">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="max-w-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-sm font-semibold text-primary bg-primary/10 px-4 py-2 rounded-full">
                Helping 100+ children in Ethiopia
              </span>
            </div>

            <div>
              <h1 className="text-foreground mb-6">
                Every Child Deserves{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
                  a Childhood
                </span>
              </h1>
              <p className="text-xl text-foreground/70 leading-relaxed">
                We provide education, nutrition, and care to street children and orphans in Ethiopia. Together, we&apos;re
                building a future where every child has hope.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link href="/become-sponsor" className="btn-primary group">
                Sponsor a Child
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link href="/become-member" className="btn-secondary">
                Join Our Community
              </Link>
            </div>

            {/* Trust badges */}
            <div className="flex gap-8 pt-8 border-t border-border">
              <div>
                <div className="text-2xl font-bold text-primary">100+</div>
                <p className="text-sm text-foreground/60">Children Supported</p>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary">20+</div>
                <p className="text-sm text-foreground/60">Years of Impact</p>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary">500+</div>
                <p className="text-sm text-foreground/60">Active Supporters</p>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative h-96 md:h-full min-h-96">
            <div className="relative w-full h-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/src/lkajdaldj.jpeg"
                alt="Children in Ethiopia receiving education"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />

              {/* Play button overlay */}
              <button
                onClick={() => setVideoOpen(true)}
                className="absolute inset-0 flex items-center justify-center group cursor-pointer"
              >
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-white/30 transition-all group-hover:scale-110">
                  <Play size={32} className="text-white fill-white" />
                </div>
              </button>
            </div>

            {/* Floating card with impact stat */}
            <div className="glass-effect absolute bottom-8 left-8 right-8 md:absolute md:bottom-12 md:right-12 md:left-auto md:w-64 p-6 rounded-xl">
              <div className="text-4xl font-bold text-primary mb-2">55+</div>
              <p className="text-sm text-foreground/80">
                Children have graduated and are now building independent futures
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
